<template>
	<div>
		<p class="Mybalance">我的学费</p>
		<div class="zhScholarship">
            <div class="zhLeft">
              <p class="remainderChild">我的学费<i>￥</i><span>{{tuition.tuition}}</span><b class="integral">(含积分{{tuition.integral_pe}})</b></p>
            </div>
            <div class=zhRight>
              <div class="zhSign"><Icon type="ios-information-outline"></Icon></div><i class="zhJiang1" @click="Tuition1">学费规则</i>
            </div>
            <div class="zhInformation1" v-show="Tuition">
              <p class="zhProblem"><span class="zhP">Q</span>学费的来源有哪些？</p>
              <p class="zhProblem1"><span class="zhP">A</span>学费的来源有两个：第一是购买诺亚财富特定产品会赠送学费；第二是诺亚财富会员的积分会按照4:1的比例折算成学费。（赠送和积分转化的具体规则及解释权由诺亚财富集团发布）</p>
              <p class="zhProblem"><span class="zhP">Q</span>学费可以用来做什么？</p>
              <p class="zhProblem1"><span class="zhP">A</span>可以在报名课程时抵扣课程报名费，其中抵扣顺序是先抵扣特定产品赠送学费，再抵扣积分。</p>
              <p class="zhProblem"><span class="zhP">Q</span>学费有有效期吗？</p>
              <p class="zhProblem1"><span class="zhP">A</span>特定产品赠送学费有效期两年，超出期限未使用的将被清零不可再使用。</p>
            </div>
          </div>
		<div class="wholeBalance">
			<div class="wholeword">全部</div>
		</div>
		<div class="detailList">
			<div class="dates">日期</div>
			<div class="income">收入/支出</div>
			<div class="detailInfo">详细信息</div>
		</div>
		<div class="dateList" v-for="tui in tuiList">
			<div class="datesList">{{tui.date}}</div>
			<div class="incomeList">{{tui.price}}(包含积分{{tui.integral}})</div>
			<div class="detailInfoList">{{tui.remark}}<span v-if="tui.order_id">，订单号：{{tui.order_id}}</span><span v-if="tui.timeout">，有效期：{{tui.timeout}}</span></div>
		</div>
		<!--<div class="clear"></div>-->
		<div class="zhhContent">
              <Page :total="zhPage.total" :page-size="20" @on-change="handlePages"></Page>
            </div>
            <div class="zhTotal">
              共{{zhPage.total}}条记录
            </div>
	</div>
</template>

<script>
	export default{
		name:"MyBalance",
		data(){
			return{
				zhTotal:0,
				Tuition:false,
				tuition:'',
				tuiList:[],
				zhPage:{},
			}
		},
		methods:{
			Tuition1(){
				if(this.Tuition==false){
					this.Tuition=true
				}else{
					this.Tuition=false
				}
			},
			handlePages(i){
        var that = this;
        that.$ajax({
          method:"post",
          url:"/api/TuitionList",
          params:{page:i}
        })
        .then(function(data){
           that.zhPage=data.data.meta.pagination;
           that.tuiList=data.data.result
        })
       }
		},
		mounted(){
			var that=this
			that.$ajax({
				method:"post",
				url:"/api/TuitionInfo"
			}).then(function(data){
				that.tuition=data.data.result
			}).catch(function(err){
				console.log(err)
			})
			
			that.$ajax({
				method:"post",
				url:"/api/TuitionList"
			}).then(function(data){
				that.zhPage=data.data.meta.pagination;
				that.tuiList=data.data.result
			}).catch(function(err){
				console.log(err)
			})
		}
	}
</script>

<style>
		.Mybalance{font-size: 20px;color: #4f4f4f;margin: 30px 0 20px 30px;}
		.remainder{width: 850px;line-height: 85px;background: #e6e8f0;margin-left: 30px;}
		.remainderChild{margin-left:30px;color: #4f4f4f;}
		.remainderChild span{font-size: 30px;color: #01b784;}
		.remainderChild i{font-style: normal;font-size: 24px;color: #01b784;margin-left: 20px;}
		.wholeBalance{height:62px;width: 850px;margin-left: 30px;border-bottom: 2px solid #e6e8f0;position: relative;}
		.wholeword{width: 90px;line-height:44px;border-bottom: 2px solid #01b784;text-align: center;color: #01b784;position: absolute;top: 16px;font-weight: 600;}
		.detailList{width: 850px;height: 40px;background: #f5f5f5;margin:30px 0 0 30px;color: #909090;}
		.dates{float: left;width:205px;text-align: center;line-height: 40px;}
		.income{float: left;width:206px;text-align: center;line-height: 40px;}
		.detailInfo{float: left;width: 420px;text-align: center;line-height: 40px;}
		.dateList{width: 850px;height: 50px;border-bottom:1px solid #e6e6e6;margin-left: 30px;color: #4f4f4f;}
		.datesList{float: left;width:205px;text-align: center;line-height: 50px;}
		.incomeList{float: left;width:206px;text-align: center;line-height: 50px;}
		.detailInfoList{float: left;width: 420px;text-align: center;line-height: 50px;}
		.clear{clear: both;}
		.integral{font-weight: 100;margin-left: 20px;color: #909090;}
		/*.router-link-active{background:#11cc99;color:#fff;}*/
		.zhLeft{float:left;overflow:hidden;display:flex;justify-content:space-start;align-items:center;height:30px;}
		.zhRight{float:right;overflow:hidden;display:flex;justify-content:space-end;align-items: center;}
		.zhSign{font-size:20px;color:#01b784;}
		.zhScholarship{position:relative;width:850px;height:85px;background:#e6e8f0;margin:30px 30px 0;box-sizing:border-box;display:flex;justify-content:space-between;align-items: center;}
		.zhJiang1{font-style:normal;margin:0 30px 0 8px;font-size:14px;color:#01b784;display:block;cursor:pointer;}
		.zhInformation1{z-index:1;position:absolute;top:65px;right:5px;width:370px;min-height:280px;background:#ffffff;box-shadow:0 0 15px rgba(0,0,0,.1);box-sizing:border-box;padding:30px;}
		.zhProblem{font-size:14px;color:#4f4f4f;padding-bottom:10px;padding-left:20px;position:relative;}
 		.zhProblem1{font-size:12px;color:#909090;padding-bottom:16px;overflow:hidden;padding-left:20px;position:relative;}
 		.zhhContent{display: flex;justify-content: center;padding-top: 30px;}
 		.ivu-page-total{display: none;}
  		.ivu-page li{border-radius: 50%;}
  		 .ivu-page li:hover{border:1px solid #11cc99;}
   		.ivu-page li:hover a{color:#11cc99}
   		.ivu-page .ivu-page-item-active:hover a{color:#ffffff}
   		.ivu-page-item-active{background-color: #11cc99;border-color: #11cc99;}
 		.zhTotal{width:100%;text-align: center;line-height: 50px;}
</style>


// WEBPACK FOOTER //
// MyBalance.vue?11c606c2